export function StatsDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.STATS + '/:action')
        .setCustomActions({
            'getNumOfArtifacts': {
                method: 'POST',
                params: {action: 'numOfArtifacts'},
                isArray: true
            },
            'getTotalNumOfIndexedArtifact': {
                method: 'GET',
                params: {action: 'numOfIndexedArtifacts'}
            }
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/stats_dao.js